import { useState, useRef, useEffect } from 'react';

export default function useArrowScroll(scrollValue: number) {
  const [showNextArrow, setShowNextArrow] = useState(false);
  const [showPrevArrow, setShowPrevArrow] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    handleShowArrows();
  }, [wrapperRef.current]);

  const handlePrevToShow = () => {
    if (wrapperRef && wrapperRef.current) {
      wrapperRef.current.scrollLeft -= scrollValue;
    }
    if (wrapperRef.current && wrapperRef.current.scrollLeft >= wrapperRef.current.scrollWidth - wrapperRef.current.offsetWidth) {
      setShowNextArrow(true);
    }
    if (wrapperRef.current?.scrollLeft === 0) {
      setShowPrevArrow(false);
      setShowNextArrow(true);
    }
  };

  const handleNextToShow = () => {
    if (wrapperRef && wrapperRef.current) {
      wrapperRef.current.scrollLeft += scrollValue;
    }

    if (wrapperRef.current && wrapperRef.current.scrollLeft + wrapperRef.current.clientWidth === wrapperRef.current.scrollWidth) {
      setShowNextArrow(false);
    }
  };

  const handleShowArrows = () => {
    if (wrapperRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = wrapperRef.current;

      if (scrollLeft + clientWidth === scrollWidth) {
        setShowNextArrow(false);
      }
      if (scrollLeft + clientWidth < scrollWidth) {
        setShowNextArrow(true);
      }
      if (scrollLeft === 0) {
        setShowPrevArrow(false);
      }
      if (scrollLeft > 0) {
        setShowPrevArrow(true);
      }
    }
  };

  const onScroll = () => handleShowArrows();

  const scrollWidth = wrapperRef.current?.scrollWidth;

  return {
    wrapperRef,
    scrollWidth,
    showNextArrow,
    showPrevArrow,
    onScroll,
    handlePrevToShow,
    handleNextToShow,
  };
}
